import { type Only } from '@dhl-ui/theme'

export const hasOwnProperty = <T = Record<string, unknown>, U = unknown>(
  object: T | unknown,
  property: U
): object is T extends object ? Only<T, U> : never => !!object && Object.hasOwn(object, String(property))
